import { inject, observer } from "mobx-react";
import * as React from "react";
import DropInComponent from "./DropInComponent.mjs";
const DEFAULT_SHOPPER_REFERENCE = "PaymentFrontendAnonymousShopper";
const CARD_SAVING_NOT_ALLOWED_SOURCES = [
  "E_MAIL",
  "ELIS_PARTNER",
  "PAYMENT_FRONTEND",
  "PRION",
  "SUPER",
  "SIMPEL",
  "POP",
  "DIIL",
  "WALK4GIG",
  "NETIKAART",
  "MULTIDEVICE_EE"
];
class CardComponent extends React.Component {
  render() {
    const { source, paymentOrderParams, referenceNumber, cardPayment } = this.props.paymentProps;
    return /* @__PURE__ */ React.createElement(
      DropInComponent,
      {
        dropInAmount: { value: this.props.paymentStore.amountInCents, currency: "EUR" },
        source,
        referenceNumber,
        showSaveCardButton: this.isCardSavingAllowed(),
        shopperReference: CardComponent.getShopperReference(cardPayment.shopperReference),
        paymentOrderParams,
        isAmountEditing: this.props.isAmountEditing,
        cardPayment,
        reload: this.props.cardStore.reloadAdyenPaymentMethodInputs
      }
    );
  }
  static getShopperReference(shopperReference) {
    return shopperReference || DEFAULT_SHOPPER_REFERENCE;
  }
  isCardSavingAllowed() {
    const shopperReference = this.props.paymentProps.cardPayment?.shopperReference;
    if (CARD_SAVING_NOT_ALLOWED_SOURCES.includes(this.props.paymentProps.source)) {
      return false;
    }
    if (!!shopperReference && shopperReference === DEFAULT_SHOPPER_REFERENCE) {
      return false;
    }
    return !!shopperReference;
  }
}
const CardComponent$1 = inject("cardStore", "paymentStore")(observer(CardComponent));
export {
  CardComponent$1 as default
};
